export const APP_THEME_TOKENS = {
  foundation: {
    font: {
      family: {
        body: 'Manrope',
        heading: 'Manrope',
        ui: 'Manrope',
        mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
      },
      size: {
        xs: '0.75rem',
        sm: '0.875rem',
        md: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
      },
      weight: {
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extraBold: 800,
      },
      lineHeight: {
        tight: 1.2,
        normal: 1.5,
        relaxed: 1.7,
      },
    },
    radius: {
      xs: 4,
      sm: 8,
      md: 12,
      lg: 16,
      xl: 24,
      full: 999,
    },
    spacing: {
      0: 0,
      xs: 4,
      sm: 8,
      md: 12,
      lg: 16,
      xl: 24,
      '2xl': 32,
    },
  },
  semantic: {
    fg: {
      primary: '#23272e',
      secondary: '#64748b',
      tertiary: '#8695aa',
      placeholder: '#b1bbc8',
      disabled: '#d5d9e2',
    },
    bg: {
      canvas: '#ffffff',
      surface: '#f6f7f9',
      subtle: '#eceef2',
      muted: '#e0e4eb',
    },
    border: {
      subtle: '#d5d9e2',
      muted: '#eceff3',
      strong: '#23272e',
    },
    action: {
      primary: '#f15e22',
      secondary: '#2b52d4',
      highlight: '#fef5ee',
      neutral: '#f6f7f9',
      disabled: '#eceef2',
    },
    status: {
      success: '#22c55e',
      info: '#2b52d4',
      warning: '#eab308',
      danger: '#ef4444',
    },
    statusSoft: {
      success: '#dcfce8',
      info: '#eef0fc',
      warning: '#fef0c3',
      danger: '#fee2e2',
    },
    surface: {
      positive: '#e8f5e9',
      info: '#eef0fc',
      danger: '#feebee',
    },
  },
  component: {
    typography: {
      defaultVariant: 'body2',
      defaultColor: 'text.secondary',
    },
    button: {
      radius: {
        sm: 8,
        md: 12,
        lg: 16,
      },
      bg: {
        transparent: '#ffffff',
        primary: '#f15e22',
        secondary: '#2b52d4',
        branding: '#f15e22',
      },
      fg: {
        primary: '#ffffff',
        secondary: '#ffffff',
        branding: '#f6f7f9',
      },
    },
  },
} as const;

export const STYLE_TOKENS = {
  font: APP_THEME_TOKENS.foundation.font,
  radius: APP_THEME_TOKENS.foundation.radius,
  spacing: APP_THEME_TOKENS.foundation.spacing,
  color: {
    text: APP_THEME_TOKENS.semantic.fg,
    background: APP_THEME_TOKENS.semantic.bg,
    border: APP_THEME_TOKENS.semantic.border,
    brand: {
      primary: APP_THEME_TOKENS.semantic.action.primary,
      secondary: '#f6f7f9',
      accent: APP_THEME_TOKENS.semantic.action.secondary,
      highlight: APP_THEME_TOKENS.semantic.action.highlight,
      disable: APP_THEME_TOKENS.semantic.action.disabled,
      border: '#f8cead',
    },
    semantic: APP_THEME_TOKENS.semantic.status,
    surface: APP_THEME_TOKENS.semantic.surface,
  },
} as const;

